<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <ng-container *mailgunIf="data.body_html; else headerWithoutSeparator">
      <email-message-header
        [header]="data.header"
        [subheader]="data.subheader_html"
        [separator]="true"
      />
    </ng-container>

    <ng-template #headerWithoutSeparator>
      <email-message-header
        [header]="data.header"
        [subheader]="data.subheader_html"
        [separator]="false"
      />
    </ng-template>
  </ng-container>

  <ng-container body>
    <ng-container *mailgunIf="data.body_html">
      <email-text [contents]="data.body_html!" />
    </ng-container>
    <ng-container *mailgunIf="data.primary_cta">
      <email-margin [height]="28" />
      <email-button
        [href]="data.primary_cta?.href!"
        [label]="data.primary_cta?.label!"
        theme="primary"
      />
    </ng-container>
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
